/*
 * @Date: 2022-07-04 17:34:40
 * @LastEditors: hanhuixian hanhuixian@lxrental.com
 */
export default {
  M: "M",
  Y: "YR",
  empty: "No data temporarily",
  stockInfo: "Stock Price Information",
  stockInfoRmk: "Data Provided by Refinitiv. Minimum 15 minutes delayed."
}